
export default class Participant {
    constructor() {
        this.firstname = null
        this.lastname = null
        this.email = null
        this.phone = null
        this.isCompany = null
        this.companyName = null
        this.orgnum = null
        this.bdate = null
    }
}
